import * as React from "react";
import MenuItemModel from "../models/MenuItemModel";
import HomeIcon from "@material-ui/icons/Home";
import SettingsIcon from "@material-ui/icons/Settings";
import AssessmentIcon from "@material-ui/icons/Assessment";
import HelpIcon from "../../components/HelpIcon";
import DocumentIcon from "@material-ui/icons/LibraryBooks";
import SearchIcon from "@material-ui/icons/Search";
import { SessionCache } from "../../helpers/cache";
import User from "../models/User";
import { isArrayValid } from "../../helpers/utility";
import {
  PERMISSION_ACCESS_ADMIN,
  PERMISSION_ACCESS_BASE,
  PERMISSION_ACCESS_CONSUMPTION_CHART,
  PERMISSION_ACCESS_CONSUMPTION_REPORT,
  PERMISSION_ACCESS_INFORM_LEVEL,
  PERMISSION_ACCESS_LEVEL_CHART,
  PERMISSION_ACCESS_LEVEL_REPORT,
} from "../models/Permission";
import CustomerModel from "../models/Customer";
import { useHubx } from "../../HubX";
import { FETCH_CUSTOMERS } from "../../Fedx";
import useConstructor from "../hooks/useConstructor";
import InstallationGroup from "../models/InstallationGroup";
import get from "lodash/get";

const useAppLinks = (): MenuItemModel[] => {
  const cache = new SessionCache();

  const [customers, setCustomer] = React.useState<null | CustomerModel[]>(() => {
    const cachedCustomers: null | CustomerModel[] = cache.get("customers");
    return cachedCustomers;
  });

  const hub = useHubx();

  useConstructor(async () => {
    // if (customers) {
    //   return;
    // }
    // const customersResult = await hub.request(FETCH_CUSTOMERS);
    // setCustomer(customersResult);
  });

  const getFirstOrDefaultInstallationDetailRoute = React.useCallback(
    (path: string) => {
      const cachedUser: User | null = cache.get("user");

      let firstCustomerWithValidGroup:
        | InstallationGroup
        | CustomerModel
        | undefined = cachedUser?.installationGroup?.find((x) => isArrayValid(x.installationList));

      if (customers) {
        let rtuFilter = true;
        firstCustomerWithValidGroup = customers.find((x) =>
          isArrayValid(x?.installations?.filter((x) => x.has_rtu))
        );

        if (!firstCustomerWithValidGroup) {
          firstCustomerWithValidGroup = customers.find((x) => isArrayValid(x?.installations));
          rtuFilter = false;
        }

        if (firstCustomerWithValidGroup) {
          const firstInstallation = rtuFilter
            ? firstCustomerWithValidGroup?.installations?.find((x) => x.has_rtu)
            : get(firstCustomerWithValidGroup, "installations[0]");
          if (firstInstallation) {
            return `/installation/${firstCustomerWithValidGroup.customer_id}/${firstInstallation?.installation_id}/${path}/`;
          }
        }
      } else {
        if (firstCustomerWithValidGroup) {
          const firstInstallation = firstCustomerWithValidGroup.installationList[0];
          return `/installation/${firstCustomerWithValidGroup.id}/${firstInstallation?.installationId}/${path}/`;
        }
      }

      return "/installation/";
    },
    [cache, customers]
  );

  const menu: MenuItemModel[] = [
    {
      name: "Home",
      route: "/home/",
      icon: <HomeIcon />,
      permission: PERMISSION_ACCESS_BASE,
    },
    {
      name: "Grupos",
      route: "/groups/",
      icon: <SettingsIcon />,
      // permission: PERMISSION_ACCESS_ADMIN,
      permission: PERMISSION_ACCESS_ADMIN,
    },
    {
      name: "Clientes",
      route: "/clients/",
      icon: <SearchIcon />,
      permission: PERMISSION_ACCESS_ADMIN,
    },
  ];

  return menu;
};

export default useAppLinks;
